import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../features';
import { actions } from '../../features/myDesign';
import { Loading } from '../shared/Loading';
import { LoadingFailed } from '../shared/LoadingFailed';
import { DialogRoute } from '../shared/routes/DialogRoute';
import { TitleHeader } from '../shared/TitleHeader';
import { DeleteFailedDialog } from './DeleteFailedDialog';
import { MyDesignDetailDialog } from './detail/MyDesignDetailDialog';
import { MyDesignHintDialog } from './MyDesignHintDialog';
import { OverwriteMyDesignDialog } from './OverwriteMyDesignDialog';
import { PleaseDownloadMyDesign } from './PleaseDownloadMyDesign';
import { TryMyDesign } from './TryMyDesign';

const myDesignStyles = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  color: #4d3906;
  overflow-y: scroll;

  .body {
    flex: 1 1 auto;
    overflow-y: scroll;
    padding: 24px 0;
  }
`;

const MyDesign: React.FC = () => {
  const { t } = useTranslation(['my_design', 'translation']);
  const history = useHistory();
  const { isLoading, uploadedMyDesign, errorType, readMyDesigns, invalidated } = useSelector(
    (state: RootState) => state.myDesign
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getMyDesign());
  }, [dispatch]);

  useEffect(() => {
    if (readMyDesigns && !invalidated) {
      history.push('/players/confirm-my-design');
    }
  }, [readMyDesigns, invalidated, history]);

  const hintPath = '/players/my-design/hint';

  return (
    <>
      <main className={myDesignStyles}>
        <TitleHeader
          title={t('top')}
          hintPath={hintPath}
          hintLabel={t('aria_help')}
          backLabel={t('translation:aria_button_back_to_home')}
          color={'#ffcad1'}
        >
          <div
            className={css`
              background: #ffcad1;
              p {
                font-size: 12px;
                width: 100%;
                max-width: 480px;
                margin: 0 auto;
                padding: 8px 16px 12px;
              }
            `}
          >
            <p>{t('top_desc_01')}</p>
          </div>
        </TitleHeader>
        <div className="body">
          {(() => {
            if (errorType === 'load-failed' || errorType === 'unstable-network') {
              return <LoadingFailed error={errorType} />;
            }
            if (uploadedMyDesign) {
              return <PleaseDownloadMyDesign myDesign={uploadedMyDesign} isLoading={isLoading} />;
            }
            if (isLoading) {
              return <Loading />;
            } else {
              return <TryMyDesign />;
            }
          })()}
        </div>
      </main>

      <DialogRoute path="/players/my-design/overwrite">
        <OverwriteMyDesignDialog />
      </DialogRoute>
      <DialogRoute path="/players/my-design/detail">
        <MyDesignDetailDialog />
      </DialogRoute>
      <DialogRoute path="/players/my-design/delete-failed">
        <DeleteFailedDialog />
      </DialogRoute>
      <DialogRoute path={hintPath}>
        <MyDesignHintDialog />
      </DialogRoute>
    </>
  );
};

export default MyDesign;
